import React, { useEffect, useRef, useState } from "react"
import { Card, Col, PopoverBody, Row, UncontrolledPopover } from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import action from "../../../assets/icons/action.svg"
import {
  fetchUnit,
  updateUnitStatus,
} from "../../../services/Inventory/inventory"
import EditUnit from "./edit"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import InventoryFilter from "../filter"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"

const Unit = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Units${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  // const location = useLocation()

  // const menuItem = loggedUser?.smenu?.find(item =>
  //   location?.pathname.includes(item?.linkTo)
  // )

  // const subMenuItem = menuItem?.submenus?.find(
  //   item => item.linkTo === `${location?.pathname}`
  // )

  // console.log(`loggedUser`, loggedUser, location, menuItem, subMenuItem)

  const [page, setPage] = useState("")

  const [unit, setUnit] = useState()
  const [count, setCount] = useState(0)
  const [search, setSearch] = useState("")
  const [status, setStatus] = useState("")
  const [editUnit, setEditUnit] = useState({ modal: false, value: "" })
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchUnit({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${`&sortOrder=asc`}${search ? `&searchText=${search}` : "&searchText"
          }${page ? `&page=${page}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setUnit(response)
      const newData = response?.data?.data || [];

      setUnit(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchData()
    
  }, [count, status, search, page, dataPerPage])

  const handleEdit = item => {
    setEditUnit({ value: item, modal: true })
  }

  const handleStatus = async id => {
    try {
      const response = await updateUnitStatus(id)
      toastSuccess(response?.message)
      setCount(count + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const columns = [
    {
      label: "Unit Code",
      renderCell: item => item?.unit_code?.toUpperCase(),
      sortKey: "unit_code",
    },
    {
      label: "Description",
      renderCell: item => (
        <div className="capitalize-letter">{item?.description}</div>
      ),
      sortKey: "description",
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <div
            className={`font-13 ${item?.status === 1 ? "status-active" : "status-inactive"
              }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </div>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {loggedUser?.permission?.some(
                permissionItem => permissionItem?.name === "units_edit"
              ) &&
                item?.status === 1 && (
                  <div
                    className="table-popup-content"
                    onClick={() => handleEdit(item)}
                  >
                    Edit
                  </div>
                )}
              <div
                className={`${item?.status === 1 ? "popover-border" : ""
                  } table-popup-content`}
                onClick={() => handleStatus(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleUpdate = () => {
    setCount(count + 1)
  }

  const handleResetValue = () => {
    setEditUnit("")
  }

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < unit?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [unit, page]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Inventory"
              breadcrumbObject={[
                { title: "Inventory", link: "/inventory" },
                { title: crumb || "Inventory Masters", link: "/inventory" },
                { title: "Units", link: "/inventory-unit" },
              ]}
            />
            {loggedUser?.permission?.some(
              permissionItem => permissionItem?.name === "units_create"
            ) && (
                <EditUnit
                  key={"x"}
                  onUpdate={handleUpdate}
                  onReset={handleResetValue}
                  buttonLabel="+&nbsp; Unit"
                  className="px-2 mb-3 me-2 btn btn-primary"
                  editItem={editUnit}
                />
              )}
          </div>
          <Card className="me-2 px-2 pb-2">
            <InventoryFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              sampleUrl={"download/units.xlsx"}
              importUrl={"units/import"}
              isExport={
                loggedUser?.permission?.some(
                  permissionItem => permissionItem?.name === "units_create"
                )
                  ? true
                  : false
              }
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                  {unit?.data?.data && (
                    <UpdateTable
                      className="mt-5"
                      nodes={unit?.data?.data}
                      paginate={unit?.data}
                      columns={columns}
                      CurrentPage={page}
                      handlePagination={handlePaginate}
                      handleSizePerPage={handleSizePerPageChange}
                      tableWidth="30% 30% 30% 10%"
                      mobileWidth="40% 40% 40% 10%"
                      isLoading={isLoadingNextPage}
                      hidePaginate={true}
                    />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Unit
